import React from 'react'
import Svg from './Svg'
export const SvgHorizontalDotsCircle = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M12.025.148C5.479.148.123 5.504.123 12.05c0 6.546 5.356 11.902 11.902 11.902 6.546 0 11.902-5.356 11.902-11.902 0-6.546-5.356-11.902-11.902-11.902zM6.431 14.43c-.952 0-1.785-.833-1.785-1.785s.833-1.785 1.785-1.785 1.785.833 1.785 1.785-.833 1.785-1.785 1.785zm5.951 0c-.952 0-1.785-.833-1.785-1.785s.833-1.785 1.785-1.785 1.785.833 1.785 1.785-.833 1.785-1.785 1.785zm5.951 0c-.952 0-1.785-.833-1.785-1.785s.833-1.785 1.785-1.785 1.666.833 1.785 1.785-.714 1.785-1.785 1.785z" />
  </Svg>
))
SvgHorizontalDotsCircle.isIcon = true
export default SvgHorizontalDotsCircle
